/**
 * G6 — Login land unlock window.
 *
 * `applyAuthenticatedSession` holds this module flag for the whole land critical
 * section so auth-hot refresh (and non-land `/me`) refuse wire except the land
 * probe itself (`forLoginLand: true`). RAM gate only — do not set durable guest
 * silence in land finally; fail → ready+null via callers/CSP.
 */

let loginLandInFlightDepth = 0;

/** Arm before land `/me` probe; pair with {@link endLoginLand} in finally. */
export function beginLoginLand(): void {
  loginLandInFlightDepth += 1;
}

/** Disarm after land probe settles (establish or fail return). */
export function endLoginLand(): void {
  if (loginLandInFlightDepth > 0) {
    loginLandInFlightDepth -= 1;
  }
}

/** True while any login land critical section is open. */
export function isLoginLandInFlight(): boolean {
  return loginLandInFlightDepth > 0;
}

/** Test-only — drop land gate between Jest cases. */
export function resetLoginLandGateForTests(): void {
  loginLandInFlightDepth = 0;
}
